/** Fenêtre préférée : à partir de 21 h heure locale. */
export const HYBRID_NIGHTLY_HOUR = 21;

function startOfLocalDay(value: Date): number {
  return new Date(value.getFullYear(), value.getMonth(), value.getDate()).getTime();
}

export function msUntilNextNightly(now = new Date()): number {
  const next = new Date(now);
  next.setHours(HYBRID_NIGHTLY_HOUR, 0, 0, 0);
  if (next.getTime() <= now.getTime()) {
    next.setDate(next.getDate() + 1);
  }
  return next.getTime() - now.getTime();
}

/**
 * Une copie max par jour local.
 * Le soir (≥ 21 h) : envoi.
 * Au réveil : rattrapage seulement si la nuit précédente a été manquée.
 */
export function shouldSendHybridCopy(lastSentAt: Date | null, now = new Date()): boolean {
  if (lastSentAt && startOfLocalDay(lastSentAt) === startOfLocalDay(now)) {
    return false;
  }
  if (now.getHours() >= HYBRID_NIGHTLY_HOUR) return true;
  if (!lastSentAt) return false;
  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  return startOfLocalDay(lastSentAt) < startOfLocalDay(yesterday);
}
